export enum RulesType {
  ExclusionRule = "ExclusionRules",
  SpecificRule = "SpecificRules",
}
